import { runImpactCalculateTourCo2ForSequence } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-co2-for-sequence';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { ImpactCo2Answer } from '../../entities/question.entity';
import { submitImpactCo2Answer } from '../submit-impact-co2-answer.action';

type Params = {
  sequenceId: number;
  answer: ImpactCo2Answer;
  submitMode: 'create' | 'edit';
};

type Result = void;

export const submitImpactCo2AnswerTourSequence = createAppAsyncThunk(
  'impactCo2/submitImpactCo2AnswerTourSequence',
  async (
    { sequenceId, answer, submitMode }: Params,
    { dispatch },
  ): Promise<Result> => {
    await dispatch(
      submitImpactCo2Answer({
        answer,
        projectId: sequenceId,
        submitMode: submitMode,
        recalculateAfterSubmit: false,
      }),
    );
    dispatch(runImpactCalculateTourCo2ForSequence({ sequenceId }));
  },
);
